import { styled } from "@mui/material/styles";

import { DialogTitle, DialogActions } from "@mui/material";

export const Title = styled(DialogTitle)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 24px 0",

  "& .MuiButtonBase-root": {
    fontSize: "1.5em",
    padding: "8px 10px",
  },
});

export const Actions = styled(DialogActions)({
  display: "flex",
  justifyContent: "space-between",
  gap: "20px",
});
